import { arrayToQueryString } from '../../utils/ApiUtils';

import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  getDocuments: (ids: string[]): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/document/documents${arrayToQueryString('ids', ids)}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  remove: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/document/documents/${id}`,
    method: 'DELETE',
  }),
  download: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/document/documents/${id}`,
    method: 'GET',
  }),
};
